module.exports = __webpack_public_path__ + "img/meauicon5.0aa3ce2c.svg";